import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent implements OnInit {

  public dataManagementMainMenu = false;
  public manageCustomersMainMenu = false;
  public manageVendorsMainMenu = false;
  public updateCustomer = false;
  public updateVendor = false;
  public appManagementMainMenu = false;

  constructor(
    private _router: Router,
    private _authService: AuthService,
  ) { }

  ngOnInit(): void {
    // Mark active parent menu when child menu is opened on page reload
    this._router.events.forEach((event) => {
      if(event instanceof NavigationEnd) {
        const urls = event['url'].split('/');
        const [ base, url, param ] = urls;
        if(url == 'manage') {
          this.dataManagementMainMenu = true;
        } else if(url == 'customers') {
          this.manageCustomersMainMenu = true;
          this.updateCustomer = param && param !== 'add' ? true : false;
        } else if(url == 'vendors') {
          this.manageVendorsMainMenu = true;
          this.updateVendor = param && param !== 'add' ? true : false;
        } else if(url === 'app-manage'){
          this.appManagementMainMenu = true;
        }
      }
    });
  }

  logout() {
    Swal.fire({
      title: 'Log Out',
      text: 'Sure you want to Log Out',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Log Out',
      confirmButtonColor: '#0b5455',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this._authService.logout({ deviceId: this._authService.deviceId });
      }
    });
  }

}
